/**
 * Created by emilgrabowiec on 27.04.2016.
 */
jQuery(document).ready(() => {
  $('.select-copyright').select2({
    placeholder: 'Choose One'
  });
  $('.select-record').select2({
    placeholder: 'Choose One'
  });
  $('.select-recordingLength').select2({
    placeholder: 'Choose One'
  });

  $('.select2-selection--single').focus(function () {
    select2_open = $(this).parent().parent().siblings('select');
    select2_open.select2('open');
  });
});
